"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hexToBrightness = exports.hexToRgb = exports.iconColor = exports.asterisk = exports.underline = exports.lineThrough = exports.capitalize = exports.lowercase = exports.uppercase = exports.centerAligned = exports.fullHeight = exports.fullWidth = void 0;

var _styled = require("../styled");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var fullWidth = function fullWidth() {
  var margin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '0px';
  return (0, _styled.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: calc(100% - ", ");\n"])), margin);
};

exports.fullWidth = fullWidth;

var fullHeight = function fullHeight() {
  var margin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '0px';
  return (0, _styled.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  height: calc(100% - ", ");\n"])), margin);
};

exports.fullHeight = fullHeight;

var centerAligned = function centerAligned() {
  var display = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'inline-flex';
  return (0, _styled.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: ", ";\n  justify-content: center;\n  align-items: center;\n"])), display);
};

exports.centerAligned = centerAligned;

var uppercase = function uppercase() {
  return (0, _styled.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  text-transform: uppercase;\n"])));
};

exports.uppercase = uppercase;

var lowercase = function lowercase() {
  return (0, _styled.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  text-transform: lowercase;\n"])));
};

exports.lowercase = lowercase;

var capitalize = function capitalize() {
  return (0, _styled.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  text-transform: capitalize;\n"])));
};

exports.capitalize = capitalize;

var lineThrough = function lineThrough() {
  return (0, _styled.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  text-decoration: line-through;\n"])));
};

exports.lineThrough = lineThrough;

var underline = function underline() {
  return (0, _styled.css)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  text-decoration: underline !important;\n"])));
};

exports.underline = underline;

var asterisk = function asterisk() {
  return (0, _styled.css)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  ::after {\n    content: ' *';\n  }\n"])));
};

exports.asterisk = asterisk;

var iconColor = function iconColor(value) {
  return (0, _styled.css)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  * {\n    fill: ", ";\n  }\n"])), value);
};

exports.iconColor = iconColor;

var hexToRgb = function hexToRgb(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? "".concat(parseInt(result[1], 16), ", ").concat(parseInt(result[2], 16), ", ").concat(parseInt(result[3], 16)) : null;
};

exports.hexToRgb = hexToRgb;

var hexToBrightness = function hexToBrightness(color) {
  var c = color === null || color === void 0 ? void 0 : color.substring(1); // strip #

  var rgb = parseInt(c, 16); // convert rrggbb to decimal

  var r = rgb >> 16 & 0xff; // extract red

  var g = rgb >> 8 & 0xff; // extract green

  var b = rgb >> 0 & 0xff; // extract blue

  return 0.2126 * r + 0.7152 * g + 0.0722 * b; // 0 - 255
};

exports.hexToBrightness = hexToBrightness;